export const TemplateData = {
  data: {
    version: "5.3.0",
    objects: [
      {
        type: "image",
        version: "5.3.0",
        originX: "left",
        originY: "top",
        left: 73.55,
        top: 134.14,
        width: 1080,
        height: 1080,
        fill: "rgb(0,0,0)",
        stroke: null,
        strokeWidth: 0,
        strokeDashArray: null,
        strokeLineCap: "butt",
        strokeDashOffset: 0,
        strokeLineJoin: "miter",
        strokeUniform: false,
        strokeMiterLimit: 4,
        scaleX: 0.2,
        scaleY: 0.21,
        angle: 359.24,
        flipX: false,
        flipY: false,
        opacity: 1,
        shadow: null,
        visible: true,
        backgroundColor: "",
        fillRule: "nonzero",
        paintFirst: "fill",
        globalCompositeOperation: "source-over",
        skewX: 0,
        skewY: 0,
        clipPath: {
          type: "rect",
          version: "5.3.0",
          originX: "left",
          originY: "top",
          left: 69.67,
          top: 141.2,
          width: 214.12,
          height: 210.73,
          fill: "rgb(0,0,0)",
          stroke: null,
          strokeWidth: 1,
          strokeDashArray: null,
          strokeLineCap: "butt",
          strokeDashOffset: 0,
          strokeLineJoin: "miter",
          strokeUniform: false,
          strokeMiterLimit: 4,
          scaleX: 1,
          scaleY: 1,
          angle: 359.24,
          flipX: false,
          flipY: false,
          opacity: 1,
          shadow: null,
          visible: true,
          backgroundColor: "",
          fillRule: "nonzero",
          paintFirst: "fill",
          globalCompositeOperation: "source-over",
          skewX: 0,
          skewY: 0,
          rx: 0,
          ry: 0,
          inverted: false,
          absolutePositioned: true,
        },
        cropX: 0,
        cropY: 0,
        src: "https://dev.api.wishfy.io/media/public/2023/10/06/12/20231006124141778_wIshFy_5c7af05aa7ca4d01b8ff1f51a4648d0a.png",
        crossOrigin: null,
        filters: [],
      },
      {
        type: "image",
        version: "5.3.0",
        originX: "left",
        originY: "top",
        left: 221.91,
        top: 304.67,
        width: 460,
        height: 436,
        fill: "rgb(0,0,0)",
        stroke: null,
        strokeWidth: 0,
        strokeDashArray: null,
        strokeLineCap: "butt",
        strokeDashOffset: 0,
        strokeLineJoin: "miter",
        strokeUniform: false,
        strokeMiterLimit: 4,
        scaleX: 0.26,
        scaleY: 0.26,
        angle: 0,
        flipX: false,
        flipY: false,
        opacity: 1,
        shadow: null,
        visible: true,
        backgroundColor: "",
        fillRule: "nonzero",
        paintFirst: "fill",
        globalCompositeOperation: "source-over",
        skewX: 0,
        skewY: 0,
        cropX: 0,
        cropY: 0,
        src: "https://dev.api.wishfy.io/media/public/2023/10/09/12/20231009123955052_wIshFy_4db0bc2d44e5439bb4c58aad5b113e21.png",
        crossOrigin: null,
        filters: [],
      },
      {
        type: "textbox",
        version: "5.3.0",
        originX: "left",
        originY: "top",
        left: 103.09,
        top: 424.85,
        width: 228.74,
        height: 19.21,
        fill: "#eb22ad",
        stroke: null,
        strokeWidth: 1,
        strokeDashArray: null,
        strokeLineCap: "butt",
        strokeDashOffset: 0,
        strokeLineJoin: "miter",
        strokeUniform: false,
        strokeMiterLimit: 4,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        flipX: false,
        flipY: false,
        opacity: 1,
        shadow: null,
        visible: true,
        backgroundColor: "",
        fillRule: "nonzero",
        paintFirst: "fill",
        globalCompositeOperation: "source-over",
        skewX: 0,
        skewY: 0,
        fontFamily:
          "https://dev.api.wishfy.io/media/public/2023/10/09/12/20231009123955058_wIshFy_f6db6d9a8b15451dbef84ad16d8302ae.ttf",
        fontWeight: "bold",
        fontSize: 17,
        text: "October 05 2023",
        underline: false,
        overline: false,
        linethrough: false,
        textAlign: "center",
        fontStyle: "normal",
        lineHeight: 1.16,
        textBackgroundColor: "",
        charSpacing: 0,
        styles: [],
        direction: "ltr",
        path: null,
        pathStartOffset: 0,
        pathSide: "left",
        pathAlign: "baseline",
        minWidth: 20,
        splitByGrapheme: false,
      },
      {
        type: "textbox",
        version: "5.3.0",
        originX: "left",
        originY: "top",
        left: 86.11,
        top: 446.83,
        width: 243.37,
        height: 16.95,
        fill: "rgb(0,0,0)",
        stroke: null,
        strokeWidth: 1,
        strokeDashArray: null,
        strokeLineCap: "butt",
        strokeDashOffset: 0,
        strokeLineJoin: "miter",
        strokeUniform: false,
        strokeMiterLimit: 4,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        flipX: false,
        flipY: false,
        opacity: 1,
        shadow: null,
        visible: true,
        backgroundColor: "",
        fillRule: "nonzero",
        paintFirst: "fill",
        globalCompositeOperation: "source-over",
        skewX: 0,
        skewY: 0,
        fontFamily:
          "https://dev.api.wishfy.io/media/public/2023/10/09/12/20231009123955058_wIshFy_f6db6d9a8b15451dbef84ad16d8302ae.ttf",
        fontWeight: "normal",
        fontSize: 15,
        text: "10:00 am",
        underline: false,
        overline: false,
        linethrough: false,
        textAlign: "center",
        fontStyle: "normal",
        lineHeight: 1.16,
        textBackgroundColor: "",
        charSpacing: 0,
        styles: [],
        direction: "ltr",
        path: null,
        pathStartOffset: 0,
        pathSide: "left",
        pathAlign: "baseline",
        minWidth: 20,
        splitByGrapheme: false,
      },
    ],
    background: "white",
    backgroundImage: {
      type: "image",
      version: "5.3.0",
      originX: "left",
      originY: "top",
      left: 0,
      top: 0,
      width: 1311,
      height: 1819,
      fill: "rgb(0,0,0)",
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: "butt",
      strokeDashOffset: 0,
      strokeLineJoin: "miter",
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.27,
      scaleY: 0.27,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: "",
      fillRule: "nonzero",
      paintFirst: "fill",
      globalCompositeOperation: "source-over",
      skewX: 0,
      skewY: 0,
      cropX: 0,
      cropY: 0,
      src: "https://dev.api.wishfy.io/media/public/2023/10/09/12/20231009123955034_wIshFy_729d341fd8434b02a8541cea099ea619.jpg",
      crossOrigin: null,
      filters: [],
    },
  },
};
